import React from 'react';
import { ReceptionContainer } from '../../../core/interfaces/receptionCotnainer.interface';
import JsBarcode from 'jsbarcode';

interface OriginContainerLabelProps {
  container: ReceptionContainer;
  supplier?: string;
  area?: string;
}

// Componente de barcode scannable que se imprime correctamente
function PrintableBarcode({ value }: { value: string }) {
  // Generar barcode inmediatamente, sin useEffect
  let imageData = '';
  
  try {
    // Crear canvas temporal
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    if (ctx) {
      // Generar barcode en el canvas temporal
      JsBarcode(canvas, value, {
        format: "CODE128",
        width: 1.6,
        height: 38,
        displayValue: false,
        background: "#ffffff",
        lineColor: "#000000",
        margin: 0
      });
      
      // Convertir a imagen base64
      imageData = canvas.toDataURL('image/png');
    }
  } catch (error) {
    console.error('Error generating barcode:', error);
  }

  return (
    <div 
      className="barcode-wrap" 
      style={{ height: '10mm', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {imageData ? (
        <img
          src={imageData}
          alt={`Barcode ${value}`}
          style={{
            height: '8mm',
            maxWidth: '100%',
          }}
        />
      ) : (
        <div style={{ 
          height: '8mm', 
          width: '100%', 
          background: '#f0f0f0', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          fontSize: '2mm',
          color: '#666'
        }}>
          Error generando barcode
        </div>
      )}
    </div>
  );
}

export const OriginContainerLabel: React.FC<OriginContainerLabelProps> = ({
  container,
  supplier = '',
  area = '',
}) => {
  const formatDate = (date?: string | Date) => {
    const d = date ? new Date(date) : new Date();
    return d.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    });
  };

  return (
    <div className="label label-large">
      {/* Header con código principal */}
      <div
        style={{
          backgroundColor: 'white',
          padding: '2mm',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'bold',
          marginBottom: '1mm',
        }}
      >
        {container.code}
      </div>

      {/* Código de barra */}
      <div style={{ marginBottom: '2mm', display: 'flex', justifyContent: 'center' }}>
        <PrintableBarcode value={container.code} />
      </div>

      {/* Código con asteriscos */}
      <div className="code-section">*{container.code}*</div>

      {/* Información del contenedor de origen */}
      <div className="info-row">
        <div className="info-label">PROVEEDOR</div>
        <div className="info-value">{supplier}</div>
      </div>

      <div className="info-row">
        <div className="info-label">ÁREA</div>
        <div className="info-value">{area}</div>
      </div>

      <div className="info-row">
        <div className="info-label">FECHA CREACION</div>
        <div className="info-value">{formatDate()}</div>
      </div>

      <div className="info-row">
        <div className="info-label">ORDEN INGRESO</div>
        <div className="info-value">{container.reception_id || '12345'}</div>
      </div>

      <div className="info-row">
        <div className="info-label">CORRELATIVO</div>
        <div className="info-value">
          {container.correlative_id
            ? `${container.correlative_id} DE 12`
            : '3 DE 12'}
        </div>
      </div>

      {/* Sección de observación manual */}
      <div
        style={{
          backgroundColor: 'white',
          height: '15mm',
          margin: '1mm 0',
          padding: '1mm',
        }}
      >
        <div
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '7px',
            marginBottom: '1mm',
          }}
        >
          OBSERVACIÓN MANUAL
        </div>
        <div
          style={{
            backgroundColor: 'white',
            height: 'calc(100% - 4mm)',
            minHeight: '10mm',
            border: 'none',
            display: 'block',
          }}
        ></div>
      </div>

      {/* Footer con código repetido */}
      <div className="code-section">*{container.code}*</div>
    </div>
  );
};

export default OriginContainerLabel;
